// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Percent40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Percent40: FC<Percent40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M12.22 17.778c-1.536 0-2.845-.543-3.928-1.628-1.084-1.085-1.625-2.395-1.625-3.93 0-1.536.542-2.845 1.627-3.928 1.086-1.084 2.396-1.625 3.931-1.625 1.535 0 2.844.542 3.928 1.627 1.083 1.086 1.625 2.396 1.625 3.931 0 1.535-.543 2.844-1.628 3.928-1.085 1.083-2.395 1.625-3.93 1.625ZM12.218 15c.77 0 1.427-.27 1.969-.81A2.67 2.67 0 0 0 15 12.227c0-.771-.27-1.427-.81-1.97a2.67 2.67 0 0 0-1.964-.812c-.771 0-1.427.27-1.97.81a2.67 2.67 0 0 0-.812 1.965c0 .77.27 1.427.81 1.969a2.67 2.67 0 0 0 1.965.812Zm15.556 18.333c-1.535 0-2.844-.542-3.928-1.627-1.083-1.086-1.625-2.396-1.625-3.931 0-1.535.543-2.844 1.628-3.928 1.085-1.083 2.395-1.625 3.93-1.625 1.536 0 2.845.543 3.928 1.628 1.084 1.085 1.625 2.395 1.625 3.93 0 1.536-.542 2.845-1.627 3.928-1.086 1.084-2.396 1.625-3.931 1.625Zm0-2.777c.77 0 1.426-.27 1.968-.81a2.67 2.67 0 0 0 .813-1.965c0-.77-.27-1.427-.81-1.968A2.67 2.67 0 0 0 27.781 25c-.77 0-1.427.27-1.968.81A2.67 2.67 0 0 0 25 27.774c0 .77.27 1.426.81 1.968a2.67 2.67 0 0 0 1.965.813ZM8.61 33.333 6.667 31.39 31.389 6.667l1.944 1.944L8.611 33.333Z" />
        </svg>
    );
};

export default Percent40;
